import React, { useMemo } from 'react'
import useI18n from '../../../i18n/useI18n'
import { getStatusColor, getStatusLabelKey, formatNumber } from '../utils'

const ApplicationsStatusCard = ({ data = {}, loading }) => {
  const { t } = useI18n()

  const entries = useMemo(() => {
    const pairs = Object.entries(data || {})
    if (!pairs.length) {
      return []
    }

    const total = pairs.reduce((sum, [, value]) => sum + Number(value || 0), 0)
    return pairs.map(([status, value]) => {
      const count = Number(value || 0)
      const percent = total > 0 ? Math.round((count / total) * 100) : 0
      return {
        status,
        count,
        percent,
        labelKey: getStatusLabelKey(status),
        color: getStatusColor(status)
      }
    }).sort((a, b) => b.count - a.count)
  }, [data])

  return (
    <div className="card dashboard-card">
      <div className="header">
        <h2><strong>{t('DASHBOARD_CARD_STATUS_TITLE')}</strong></h2>
      </div>
      <div className="body">
        {loading && !entries.length && (
          <div className="skeleton-list">
            {[...Array(5)].map((_, index) => (
              <div className="skeleton-line" key={index}></div>
            ))}
          </div>
        )}
        {!loading && !entries.length && (
          <div className="empty-state">{t('DASHBOARD_CARD_EMPTY_STATE')}</div>
        )}
        {entries.map((entry) => (
          <div className="status-row" key={entry.status}>
            <div className="status-label">
              <span className="status-dot" style={{ backgroundColor: entry.color }}></span>
              {t(entry.labelKey)}
            </div>
            <div className="status-value">
              <span>{formatNumber(entry.count)}</span>
              <span className="status-percent">{entry.percent}%</span>
            </div>
            <div className="status-bar">
              <div
                className="status-bar-fill"
                style={{ width: `${entry.percent}%`, backgroundColor: entry.color }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ApplicationsStatusCard

